import React from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';

const useStyles = makeStyles(theme => ({
  title: {
    fontWeight: 500,
    whiteSpace: 'nowrap',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  count: {
    ...theme.typography.body2,
    color: theme.palette.grey[600],
    whiteSpace: 'nowrap',
    display: 'flex',
    width: 'inherit',
    fontSize: 12,
    justifyContent: 'flex-end'
  },
  info: {
    padding: theme.spacing(0, 1)
  }
}));

export interface UserListItemProps {
  messageId: string;
  children: React.ReactNode;
  className?: string;
}

const UserSummaryItem: React.FC<UserListItemProps> = ({
  messageId,
  children,
  className
}: UserListItemProps) => {
  const classes = useStyles();

  return (
    <div className={classnames(classes.info, className)}>
      <div className={classes.title}>
        <FormattedMessage id={messageId} />
      </div>
      <div className={classes.count}>{children}</div>
    </div>
  );
};

export default UserSummaryItem;
